import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  SupportTicket,
  SupportTicketMessage,
} from '@app/models/supportTicket/supportTicket.model';

export interface SearchQueryResponseData {
  image: string;
  text: string;
  type: string;
  title: string;
  score: number;
  url: string;
  category?: any;
}

@Injectable()
export class SupportService {
  dashBoardbaseHref = `${environment.dashboardBaseRef}api/support`;
  basHref = `${environment.apiUrl}/support-ticket`;
  vectorBaseHref = `${environment.vectorServiceUrl}`;

  constructor(private http: HttpClient) {}

  createSupportTicket(ticketData): Observable<any> {
    const url = `${this.basHref}/create`;
    return this.http.post(url, ticketData);
  }

  getSupportMainCategories(): Observable<any> {
    const url = `${this.dashBoardbaseHref}/`;
    return this.http.get(url);
  }

  searchFaqEmbeddings(query: string): Observable<SearchQueryResponseData[]> {
    let params = new HttpParams().set('query', query);
    const contentType = 'FAQ';
    if (query) {
      params = params.set('contentType', contentType);
    }

    /* Omit for now not relevant using vector approach
    params = params.set(
      'userRole',
      this.userRole === 'pp' ? 'hh' : this.userRole !== 'to' ? 'both' : 'to',
    );*/
    const url = `${environment.dashboardBaseRef}api/search/global-search-engine`;
    return this.http.get<any[]>(url, { params });
  }

  getSupportTickets(): Observable<SupportTicket[]> {
    const url = `${this.basHref}/user`;
    return this.http.get<SupportTicket[]>(url);
  }

  getSupportTicketByUid(uid: string): Observable<SupportTicket> {
    const url = `${this.basHref}/detail/uid/${uid}`;
    return this.http.get<SupportTicket>(url);
  }

  createSupportTicketMessage(
    supportTicketId: number,
    data: any,
  ): Observable<SupportTicketMessage> {
    const url = `${this.basHref}/${supportTicketId}/message`;
    return this.http.post<SupportTicketMessage>(url, {
      ...data,
      supportTicketId,
    });
  }
}
